import { clsx } from "clsx";
import { RadioGroup } from "radix-ui";
import { Icon, type IconName } from "../icons";

interface RadioGridItemProps {
	value: string;
	iconName: IconName;
	title: string;
	description?: string;
}

export function RadioGridItem({ value, iconName, title, description }: RadioGridItemProps) {
	return (
		<RadioGroup.Item
			className={clsx(
				"card p-6",
				"data-[state=checked]:bg-accent-500/5 data-[state=checked]:border-accent-500 data-[state=checked]:**:stroke-accent-500",
				"ring-accent-500/10 focus:ring-4 focus:border-accent-500",
				"cursor-pointer",
				"grid grid-cols-[max-content_1fr] gap-x-6 items-center place-items-start",
				description ? "grid-rows-2" : "grid-rows-1",
			)}
			value={value}
		>
			<div className="row-span-2">
				<Icon
					name={iconName}
					size={28}
				/>
			</div>
			<p className="col-start-2 font-semibold">{title}</p>
			{/* The description wraps rather than clipping. A hint long enough to need a second line
			    is the one worth reading, and an ellipsis takes its end — which is where a warning
			    sits. */}
			{description && (
				<p className="col-start-2 row-start-2 w-full label text-left">{description}</p>
			)}
		</RadioGroup.Item>
	);
}
